/**
 *  @class
 *  @function RemoveAll
 *
 *  Fix: the original read document.getElementById('mini-cart__notes').value directly.
 *  That field only exists when the "order note" setting is on, so with it off the
 *  script threw before the fetch ran and "Remove all" did nothing. The note is now
 *  optional, and the loading state is cleared even if the request fails.
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');

      var noteField = document.getElementById('mini-cart__notes');
      var payload = noteField ? { note: noteField.value } : {};
      var clearUrl = (window.theme && theme.routes && theme.routes.cart_clear_url) || '/cart/clear';

      var done = function () {
        this.classList.remove('loading');
        if (this.drawer && typeof this.drawer.refresh === 'function') {
          this.drawer.refresh();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }.bind(this);

      fetch(clearUrl + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(done)
        .catch(function (e) {
          console.error('Remove all failed', e);
          done();
        });
    }
  }
  customElements.define('remove-all', RemoveAll);
}
